import axios from 'axios'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import authRequest from 'utils/authRequest'
import corporateRequest from 'utils/corporateRequest'
import initializeApp from 'utils/initializeApp'
import instituteRequest from 'utils/instituteRequest'
import searchRequest from 'utils/searchRequest'
import studentRequest from 'utils/studentRequest'
import { searchConfig } from 'utils/config'
import elasticSearchSyncRequest from '../../utils/elasticSearchSyncRequest'
import moment from 'moment'
const currentDate = moment().format('YYYY-MM-DD'); 

export const setStudentData = payload => {
  return {
    type: 'SET_STUDENT_DATA',
    payload,
  }
}
export const setExternalAppliedEventData = data => {
  //console.log(data, 'hii')
  return {
    type: 'SET_EXT_EVENT_DATA',
    data,
  }
}

export const setResumeData = payload => {
  return {
    type: 'SET_RESUME_DATA',
    payload,
  }
}

export const setCampusDetails = name => {
  return {
    type: 'SET_CAMPUS_DETAILS',
    name,
  }
}

export const setSkillsList = data => {
  return {
    type: 'SET_SKILLS_LIST',
    data,
  }
}

export const setDegreeList = list => {
  return {
    type: 'SET_DEGREE_LIST',
    list,
  }
}

export const setUniversityList = data => {
  return {
    type: 'SET_UNIVERSITY_LIST',
    data,
  }
}

export const setToken = token => {
  return {
    type: 'SET_TOKEN',
    token,
  }
}

export const setListOfCountry = list => {
  return {
    type: 'SET_LIST_OF_COUNTRY',
    list,
  }
}
export const setListOfState = list => {
  return {
    type: 'SET_LIST_OF_STATE',
    list,
  }
}
export const setListOfCity = list => {
  return {
    type: 'SET_LIST_OF_CITY',
    list,
  }
}

export const setListOfSkill = list => {
  return {
    type: 'SET_LIST_OF_SKILL',
    list,
  }
}

export const setFunctionsList = data => {
  return {
    type: 'SET_FUNCTIONS_LIST',
    data,
  }
}

export const setDesignationsList = data => {
  return {
    type: 'SET_DESIGNATION_LIST',
    data,
  }
}

export const setIndustrysList = data => {
  return {
    type: 'SET_INDUSTRY_LIST',
    data,
  }
}

export const getStudentData = studentId => async (dispatch, getState) => {
  // Skip API call if studentId is undefined
  if (!studentId) {
    //console.log('Student ID is not available yet, skipping student data fetch')
    return {}
  }

  try {
    const response = await studentRequest.get(`/students/${studentId}`)

    dispatch(setStudentData(response.data.data))
    if (
      response.data?.data?.lastAppliedEventIds?.length
    ) {
      let lastAppliedEventIds = response?.data?.data?.lastAppliedEventIds?.[0]
      const mappedEvent = await instituteRequest.get(
        `/institutes/events/${lastAppliedEventIds}?studentId=${studentId}`
      )
      if (mappedEvent?.data?.data) {
        //console.log(mappedEvent?.data?.data, 'hiii')
        dispatch(setExternalAppliedEventData(mappedEvent?.data?.data))
      } else {
        dispatch(setExternalAppliedEventData(null))
      }
    }
    return response?.data?.data || {}
  } catch (error) {
    //console.log('Error in getting student data', error)
  }
}

export const getCollege = campusId => async (dispatch, getState) => {
  try {
    if (campusId) {
      const response = await instituteRequest.get(
        `/institutes/campus/${campusId}`
      )
      dispatch(setCampusDetails(response.data.data))
    }
  } catch (error) {
    //console.log('Error in getting institute data', error)
  }
}

export const sendOtp = id => async (dispatch, getState) => {
    try {
      let response = await authRequest.post(`/user/sendotp/${id}`)
      response?.data?.message === 'Success' &&
        SuccessMessage('OTP Sent Successfully')
      return response?.data?.message === 'Success'
    } catch (error) {
      //console.log('Error in send opt', error)
      return error
    }
}

export const checkOtp = (otp, id) => async (dispatch, getState) => {
    try {
      const data = await authRequest.post(`/user/verifyotp/${id}/${otp}`)
      dispatch(setToken(data?.data?.data?.resetToken))
      localStorage.clear()
      sessionStorage.setItem('token', data?.data?.data?.token)
      initializeApp(data?.data?.data?.token)
      SuccessMessage('OTP Verified Successfully')
      return data
    } catch (error) {
      return error?.response
    }
}

export const resetPwd = data => async (dispatch, getState) => {
    try {
      await authRequest.put(`/user/resetpassword/studentRegistration`, data)
      SuccessMessage('Password Created Successfully')
      return true
    } catch (error) {
      //console.log('Error in publishing role', error)
      return error
    }
}

export const notInterested =
  (studentId, data) => async (dispatch, getState) => {
      try {
        await studentRequest.post(`/students/${studentId}/notintrested`, data)
        return true
      } catch (error) {
        //console.log('Error in not intrested', error)
        return error
      }
  }

export const activeStatus = (studentId, data) => async (dispatch, getState) => {
    try {
      await studentRequest.post(`/students/${studentId}/status`, data)
      return true
    } catch (error) {
      //console.log('Error in the status', error)
      return error
    }
}

export const updateStudentData =
  (studentId, data) => async (dispatch, getState) => {
      try {
        await studentRequest.put(`/students/${studentId}`, data)
        const payload = {
          "query_date": currentDate
      }
        await elasticSearchSyncRequest.post(`/sync/student_crud_skill`,payload)
        await elasticSearchSyncRequest.post(`/sync/skill_master`,payload)
        return true
      } catch (error) {
        //console.log('Error in publishing role', error)
        return error
      }
  }

export const getDegreeData =
  (searchValue, degreeType, isPaginate = true) =>
  async (dispatch, getState) => {
      try {
        let search = searchValue ? `&search=${searchValue}` : ''
        let pagination = isPaginate ? `pageNo=0&pageLimit=500` : ''

        let degreeOption
        if (
          degreeType === 'ug' ||
          degreeType === 'pg' ||
          degreeType === 'phd' ||
          degreeType === 'DIPLOMA' ||
          degreeType === 'pgdiploma'
        ) {
          degreeOption =
            degreeType === 'pgdiploma'
              ? 'P_G_DIPLOMA'
              : degreeType.toUpperCase()
        }
        let degree = degreeOption ? `&degreeType=${degreeOption}` : ''
        const data = await instituteRequest.get(
          `/institutes/search/degrees?${pagination}${search}${degree}`
        )
        return data?.data?.data
        // dispatch(setDegreeList(data?.data?.data))
        // return data?.data?.data
      } catch (error) {
        //console.log('Error in getting degree data', error)
        return error
      }
  }

export const getUniversityList = searchValue => async (dispatch, getState) => {
  let SearchKey = searchValue ? `?search=${searchValue}` : ''
  try {
    const result = await instituteRequest.get(
      `/institutes/search/universities${SearchKey}`
    )
    dispatch(setUniversityList(result?.data?.data))
    return result
  } catch (error) {
    ErrorMessage(error?.message)
    dispatch(setUniversityList({}))
  }
}

export const getFile = async (url = '', file = '', fileURL) => {
  if (url && file) {
    try {
      let fileType = file.type
      let options = {
        headers: {
          'Content-Type': fileType,
        },
      }
      const { status } = await axios.put(url, file, options)
      if (status >= 200 && status < 300) {
        SuccessMessage('File Uploaded Successfully!')
        return fileURL
      }
      return false
    } catch (error) {
      ErrorMessage('Failed to upload!')
      return false
    }
  } else {
    ErrorMessage('Failed to upload!')
    return false
  }
}

export const uploadFile = (file, fileName) => async () => {
    try {
      if (file) {
        const data = await authRequest.post(`/signedURL`, {
          files: [
            {
              fileName: fileName,
            },
          ],
        })

        if (data.status >= 200 && data.status < 300) {
          let url = getFile(
            data?.data?.data[0]?.signedURL,
            file,
            data?.data?.data[0]?.fileURL
          )
          return url
        }
      }
      return false
    } catch (error) {
     
      ErrorMessage('Failed to upload!')
      return false
    }
}

export const deleteFile = fileUrl => async () => {
    try {
      if (fileUrl) {
        const data = await authRequest.delete(`/deleteFile`, {
          data: { fileUrl: fileUrl },
        })

        if (data.status >= 200 && data.status < 300) {
          return true
        }
      } else {
        return false
      }
    } catch (error) {
      return false
    }
}

export const updateCurrentState =
  (studentId, currentState) => async (dispatch, getState) => {
    let payload = {
      state: currentState,
    }
      try {
        await studentRequest.patch(
          `/students/${studentId}/updateState`,
          payload
        )
        return true
      } catch (error) {
        //console.log('Error in publishing role', error)
        return error
      }
  }

export const deleteEducation = educationId => async dispatch => {
    try {
      await studentRequest.delete(`/students/education/${educationId}`)
      return true
    } catch (error) {
      //console.log('Error in deleted education', error)
      return error
    }
}

export const updateNotification = (userId, payload) => async dispatch => {
    try {
      await authRequest.put(`/user/${userId}/notification-preference`, payload)
      SuccessMessage('Notification Updated successfully')
      return true
    } catch (error) {
      //console.log('Error in notification', error)
      return error
    }
}

export const getListOfCountries =
  (search, isPaginate = true, setLoading) =>
  async dispatch => {
   
      try {
        if (setLoading) {
          setLoading(true)
        }
        let searchValue = search ? `&search=${search}` : ''
        let pagination = isPaginate ? `currentPage=0&pageLimit=50` : 'currentPage=0&pageLimit=50'
        const data = await searchRequest.get(
          `/search/countries?${pagination}${searchValue}`
        )
        let listOfCountry = data?.data?.data?.result
        dispatch(setListOfCountry(listOfCountry || []))
        if (setLoading) {
          setLoading(false)
        }
        return listOfCountry
       
      } catch (error) {
        //console.log('Error in while getting counties', error)
        if (setLoading) {
          setLoading(false)
        }
      }
    
  }

export const getListOfState =
  (countyId, search, isPaginate = true, setLoadingState) =>
  async dispatch => {
    
      try {
        if (setLoadingState) {
          setLoadingState(true)
        }
        let county = countyId ? `&countryId=${countyId}` : ''
        let searchValue = search ? `&search=${search}` : ''
        let pagination = isPaginate ? `currentPage=0&pageLimit=50` : 'currentPage=0&pageLimit=50'
        const data = await searchRequest.get(
          `/search/states?${pagination}${county}${searchValue}`
        )
        dispatch(setListOfState(data?.data?.data?.result || []))
        if (data?.data?.data?.result?.length === 0) {
          !searchValue &&
            ErrorMessage('No states available for selected country!')
        }
        if (setLoadingState) {
          setLoadingState(false)
        }
        return data?.data?.data?.result
       
      } catch (error) {
        //console.log('Error in while getting States', error)
        if (setLoadingState) {
          setLoadingState(false)
        }
      }
  
  }

export const getListOfCity =
  (countyId, stateId, search, isPaginate = true, setLoadingCity) =>
  async dispatch => {
    let county = countyId ? `&countryId=${countyId}` : ''
    let state = stateId ? `&stateId=${stateId}` : ''
    let searchValue = search ? `&search=${search}` : ''
    let pagination = isPaginate ? `currentPage=0&pageLimit=50` : 'currentPage=0&pageLimit=50'

      try {
        setLoadingCity(true)
        const data = await searchRequest.get(
          `/search/cities?${pagination}${county}${state}${searchValue}`
        )
        dispatch(setListOfCity(data?.data?.data?.result || []))
        if (data?.data?.data?.result?.length === 0) {
          !searchValue &&
            ErrorMessage('No cities available for selected state!')
        }
        setLoadingCity(false)
        return data?.data?.data?.result

      } catch (error) {
        //console.log('Error in while getting city', error)
        setLoadingCity(false)
      }
    
  }

export const getSkillList =
  ({ pageNum = 0, pageLimit = 500, search, isPaginate = true }) =>
  async (dispatch, getState) => {
    let pageNo = pageNum || 0
    let searchQ = search ? `&search=${search}` : ''

    let pagination = isPaginate ? `pageLimit=${pageLimit}&pageNo=${pageNo}` : ''
    try {
      const result = await studentRequest.get(
        `students/search/skills?${pagination}${searchQ}`
      )
      dispatch(setListOfSkill(result?.data?.data || {}))
      return result
    } catch (error) {
      //console.log('Error in while getting skills', error)
    }
  }

export const getListOfSkills =
  ({ pageNum = 0, pageLimit = 500, search, ids = [], isPaginate = true }) =>
  async (dispatch, getState) => {
    let pageNo = pageNum || 0
    let searchQ = search ? `&search=${search}` : ''
    let pagination = isPaginate ? `pageLimit=${pageLimit}&pageNo=${pageNo}` : ''
    try {
      const result = await studentRequest.post(
        `students/skills/list?${pagination}${searchQ}`,
        ids?.length ? { ids } : {}
      )
      dispatch(setSkillsList(result?.data?.data || {}))
      return result
    } catch (error) {
      //console.log('Error in getting list of skills =>', error?.message)
      ErrorMessage(error?.message)
      dispatch(setSkillsList({}))
    }
  }

export const updateStatusPending = studentID => async dispatch => {
    try {
      await studentRequest.patch(`/students/${studentID}/changeStatusToPanding`)

      return true
    } catch (error) {
      //console.log('Error in Status', error)
      return error
    }
}

export const updateCvDetails = (studentID, cvUrl) => async () => {
  try {
    await studentRequest.put(
      `/students/${studentID}/cvUpdate`,
      cvUrl
    )

    getStudentData(studentID)
    return true
  } catch (error) {
    //console.log('Error in Status', error)
  }
}

export const updateUserProfile = (studentID, url) => async () => {
  try {
    await studentRequest.put(
      `/students/${studentID}/profileUpdate`,
      url
    )

    return true
  } catch (error) {
    //console.log('Error in Status', error)
  }
}

export const getFunctionsList =
  (searchValue, pageLimit = 20) =>
  async (dispatch, getState) => {
    let SearchKey = searchValue ? `&search=${searchValue}` : ''

    try {
      const result = await corporateRequest.get(
        `functions?currentPage=1&pageLimit=${pageLimit}${SearchKey}`
      )
      dispatch(setFunctionsList(result?.data?.data))

      return result
    } catch (error) {
      //console.log('Error in getting functions list =>', error?.message)
      ErrorMessage(error?.message)
      dispatch(setFunctionsList({}))
    }
  }
export const getDesignationsList =
  (searchValue, functionId, pageLimit = 20) =>
  async (dispatch, getState) => {
    let SearchKey = searchValue ? `&search=${searchValue}` : ''
    let funcId = functionId ? `&functionId=${functionId}` : ''
    try {
      const result = await corporateRequest.get(
        `designations?currentPage=1&pageLimit=${pageLimit}${funcId}${SearchKey}`
      )
      dispatch(setDesignationsList(result?.data?.data))
      return result
    } catch (error) {
      //console.log('Error in getting designations list =>', error?.message)
      ErrorMessage(error?.message)
      dispatch(setDesignationsList({}))
    }
  }

export const getIndustryList =
  (searchValue, pageLimit = 100) =>
  async (dispatch, getState) => {
    let SearchKey = searchValue ? `&search=${searchValue}` : ''

    try {
      const result = await corporateRequest.get(
        `industries?currentPage=1&pageLimit=${pageLimit}${SearchKey}`
      )
      dispatch(setIndustrysList(result?.data?.data))
      return result
    } catch (error) {
      //console.log('Error in getting functions list =>', error?.message)
      ErrorMessage(error?.message)
      dispatch(setIndustrysList({}))
    }
  }

export const getCrudDegreeData =
  (searchValue, degreeType, isPaginate = true) =>
  async (dispatch, getState) => {
      try {
        let search = searchValue ? `&search=${searchValue}` : ''
        let pagination = isPaginate ? `&pageNo=0&pageLimit=50` : ''

        let degreeOption
        if (
          degreeType === 'ug' ||
          degreeType === 'pg' ||
          degreeType === 'phd' ||
          degreeType === 'DIPLOMA' ||
          degreeType === 'pgdiploma'
        ) {
          degreeOption =
            degreeType === 'pgdiploma'
              ? 'P_G_DIPLOMA'
              : degreeType.toUpperCase()
        }
        let degree = degreeOption ? `&degreeType=${degreeOption}` : ''
        const data = await instituteRequest.get(
          `/institutes/search/degrees?status=1${pagination}${search}${degree}`
        )
        return data?.data?.data
      } catch (error) {
        //console.log('Error in getting degree data', error)
        return error
      }
  }

export const getCrudDepartmentData =
  (searchValue, isPaginate = true) =>
  async (dispatch, getState) => {
      try {
        let search = searchValue ? `&search=${searchValue}` : ''
        let pagination = isPaginate ? `&pageNo=0&pageLimit=50` : ''

        const data = await instituteRequest.get(
          `/institutes/search/streams?${pagination}&status=1${search}`
        )
        return data?.data?.data
      } catch (error) {
        //console.log('Error in getting department data', error)
        return error
      }
  }

export const getCrudSpecialisationData =
  (searchValue, isPaginate = true) =>
  async (dispatch, getState) => {
      try {
        let search = searchValue ? `&search=${searchValue}` : ''
        let pagination = isPaginate ? `&pageNo=0&pageLimit=50` : ''

        const data = await instituteRequest.get(
          `/institutes/search/specialisations?${pagination}&status=1${search}`
        )
        return data?.data?.data
      } catch (error) {
        //console.log('Error in getting specialisation data', error)
        return error
      }
  }


export const searchAPI =
  (type, search = '', payload) =>
  async (dispatch, getState) => {
      try {
        const result = await searchRequest.post(`/search/${type}`, {
          ...payload,
          name: undefined,
          q: search,
        })
        return result?.data?.data?.hits?.hits?.map(item => item?._source)
      } catch (error) {
        //console.log(`Error in getting list of ${type} =>`, error?.message)
        ErrorMessage(`Error in getting list of ${type}`)
        return []
      }
  }


  export const getEligibilityCriteria =
  ({ searchValue = '', searchType = 'ALL', searchField = [], degreeId = '', departmentId = '' }) =>
  async (dispatch, getState) => {

    const state = getState()
    const instituteId = state?.studentData?.studentDetails?.instituteCampusId
    //console.log(instituteId,'instituteId')
     let filters = [
   
      {
        type: 'terms',
        field: 'instituteCampuseId',
        value: [
          instituteId
        ],
      },
      degreeId &&  {
        "type": "terms",
        "field": "degreeId.keyword",
        "value": [
          degreeId
        ]
    } ,
    departmentId &&  {
      "type": "terms",
      "field": "streamId.keyword",
      "value": [
        departmentId
      ]
  } ,
  (searchType === "DEGREE" || searchType === "STREAM" || searchType === "ALL") && {
    field: "courseStatus",
    value: 1
  }
    ].filter(Boolean);

let output = [];

if (searchField?.length > 0) {
  output = searchField?.map(value => ({
    field: "type.keyword",
    value
  }));
}
    if(searchValue && searchType=="STREAM" || searchType=="SPECIALISATION" ){
      searchValue = searchValue.toLowerCase()
    }
    let payLoad = searchConfig?.degree_streams_specialisation_course
    payLoad.q = searchValue || ''
    payLoad.searchType = searchType
    payLoad.filters = filters
    payLoad.should = output

    try {
      const result = await searchRequest.post(
        `/search/degrees/streams/specialisations/events`,
        payLoad
      )
      //console.log(result,'result?.data?.data')
      return result?.data?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
     
  }